import { render } from "./SidebarList.vue?vue&type=template&id=85634a6c"
import script from "./SidebarList.vue?vue&type=script&lang=js"
export * from "./SidebarList.vue?vue&type=script&lang=js"

import "@/assets/styles/layout/sidebar.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__